export function reformatLocale(locale: string) {
    let lang = locale.replace('_', '-');
    if (lang === 'en') {
        lang = 'en-GB';
    }

    return lang;
}
